<template>
  <div>
    <div class="d-flex position-relative" :class="textAreaClass">
      <span class="labelStyle" v-if="showTitle" :style="title.length > 12 ? { whiteSpace: 'none' } : { whiteSpace: 'nowrap' }">{{ title }}</span>
      <vue-editor
        v-if="!quill_disabled"
        ref="editor"
        id="quill-container"
        v-model="inputVal"
        :editor-toolbar="customToolbar"
        :editorOptions="editorSettings"
        :disabled="quill_disabled"
        @focus="setFocus"
      />
    </div>
    <div class="d-flex justify-content-end align-items-center mt-3">
      <b-button
        @click="
          $bvModal.show('image-upload')
          image = ''
          imageTag = ''
        "
        variant="primary"
        ><span>آپلود تصویر</span> <i class="fas fa-image ms-2"></i>
      </b-button>
    </div>
    <b-modal id="image-upload" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title no-close-on-backdrop @close="$bvModal.hide('image-upload')">
      <template #modal-title>آپلود تصویر</template>
      <div class="p-3">
        <ImageUploader
          :img="image"
          :uploadLoading="bannerImageLoading"
          title="عکس را انتخاب کنید"
          @uploadImage="uploadbannerImage"
          @deleteImage="
            image = ''
            imageTag = ''
          "
        />
      </div>
      <div class="d-flex">
        <BaseText v-model="imageTag" title="تگ" />
        <b-button class="ms-3" @click="copyToClipboard" variant="primary"><span>کپی</span> <i class="fas fa-copy ms-2"></i> </b-button>
        <b-button class="ms-2" @click="$bvModal.hide('image-upload')" variant="secondary"><span>بستن</span> </b-button>
      </div>
    </b-modal>
    <Toast :title="toast.message" :error="toast.error" :showToast="toast.message !== ''" />
  </div>
</template>

<script>
// import { VueEditor } from 'vue2-editor'
import { VueEditor, Quill } from 'vue2-editor'
import ImageResize from 'quill-image-resize-vue'
import { ImageDrop } from 'quill-image-drop-module'
import ImageUploader from '../../../user/ImageUploader.vue'
import fileMannager from '../../../../services/file'
import BaseText from './BaseText.vue'
import Toast from '../../Toast.vue'

Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

const editors = document.querySelectorAll('#quill-container')
editors.forEach((editor) => {
  if (editor.previousSibling.querySelector('.ql-toolbar span').classList.contains('js-fix')) return
  const span = document.createElement('span')
  span.classList.add('ql-formats', 'js-fix')
  const button = document.createElement('button')
  span.appendChild(button)
  span.style.display = 'none'
  editor.previousSibling.insertBefore(span, editor.previousSibling.firstChild)
})

export default {
  components: { VueEditor, ImageUploader, BaseText, Toast },
  data() {
    return {
      image: '',
      imageTag: '',
      bannerImageLoading: false,
      quill_disabled: true,
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {},
        },
      },
      toast: {
        message: '',
        error: false,
      },
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike', 'link'],
        [
          {
            color: [],
          },
          {
            background: [],
          },
        ],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ header: 1 }, { header: 2 }],
        ['blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [this.hasImage ? 'image' : ''],
        ['code-block'],
        // [{align : "right"},{align: "left"}]
      ],
    }
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    textAreaClass: {
      type: String,
      default: '',
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    value: {
      default: null,
    },
    hasImage: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val.replace(/&lt;/g, '<').replace(/&gt;/g, '>'))
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.quill_disabled = false
    })
    if (this.$refs?.editor?.quill) {
      this.$refs.editor.quill.format('align', 'right')
    }

    // this.$refs.editor.quill.format('direction', 'rtl')
  },
  methods: {
    setFocus() {
      this.$refs.editor.quill.format('align', 'right')
    },
    async uploadbannerImage(e) {
      this.bannerImageLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.bannerImageLoading = false
      this.image = req.data.data.downloadUrl
      this.imageTag = `<img src="${req.data.data.downloadUrl}">`
    },
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.imageTag)
        this.$bvToast.toast('متن با موفقیت کپی شد', {
          title: 'موفقیت',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 3000,
        })
        this.toast = {
          message: 'متن با موفقیت کپی شد',
        }
        setTimeout(() => {
          this.toast = {
            message: '',
          }
        }, 5000)
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .ck.ck-list__item,
::v-deep .ck.ck-dropdown__panel.ck-dropdown__panel_se {
  min-width: fit-content !important;
}
.labelStyle {
  width: 91px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  text-align: right;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
}
::v-deep .main__editor ~ div .ck-editor__main {
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
}
::v-deep .quillWrapper {
  width: 100%;
  max-width: 90%;
  min-height: 110px !important;
  background: #fff;
}
::v-deep .ql-container {
  max-height: 400px;
  overflow: auto;
}
::v-deep .ql-container::-webkit-scrollbar {
  display: none;
}

::v-deep .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  right: -15px;
}

::v-deep .ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: 0 !important;
}
::v-deep .ql-snow .ql-tooltip {
  position: fixed !important;
  z-index: 10000;
}
::v-deep .inputStyle {
  padding: 0.5rem 0.75rem !important;
  width: 100%;
}
</style>
